import { Route, Routes } from 'react-router-dom';
import Layout from './components/base/layout/AppLayout/AppLayout';
import { Logic } from './logic/logic';
import BlankEtaShareModule from './modules/BlankEtaShareModule/BlankEtaShareModule';
import DispatcherEtaShareModule from './modules/DispatcherEtaShareModule/DispatcherEtaShareModule';
import DriverEtaShareModule from './modules/DriverEtaShareModule/DriverEtaShareModule';
import MapModule from './modules/MapModule/MapModule';

interface Props {
    logic: Logic;
}

const App = (props: Props) => {
    return (
        <Layout>
            <MapModule logic={props.logic} />
            <Routes>
                <Route path="/" element={<BlankEtaShareModule />} />
                <Route path="/:code" element={<DriverEtaShareModule logic={props.logic} />} />
                <Route path="/driver/:code" element={<DriverEtaShareModule logic={props.logic} />} />
                <Route path="/dispatcher/:code" element={<DispatcherEtaShareModule logic={props.logic} />} />
            </Routes>
        </Layout>
    );
};

export default App;
